<template>
  <div class="setPwd login_common">
    <nav-top :navTitle="nav_title"/>
    <div class="section">
      <div class="userInfo flex_column_center">
        <div class="userImage">
          <img src="@/assets/icon/logo_2.png" />
        </div>
        <div class="userEmail">
          <div>
            {{ username }}
          </div>
        </div>
      </div>

      <el-form ref="form" :model="form" :rules="rules" class="form">
        <el-form-item prop="pwd">
          <el-input v-model="form.pwd" type="password" placeholder="새 비밀번호" maxlength="20" @blur="handleInputBlur" />
        </el-form-item>
        <el-form-item prop="pwdcheck">
          <el-input v-model="form.pwdcheck" type="password" placeholder="새 비밀번호 확인" maxlength="20" @blur="handleInputBlur" />
        </el-form-item>
        <div class="setpwd_tip">
          8~20자 이내로 설정해주세요.
        </div>
        <el-button v-waves class="btn_big setpwd_btn" @click="handleSetPwd()">
          비밀번호 변경
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
  import NavTop from '@/components/navTop'
  import waves from '@/directive/waves'

  import { requestUpdatePassword } from '@/http/api/account'

  let app = null

  export default {
    name: 'Resetpassword',
    directives: { waves },
    components: { NavTop },
    data () {
      var validpwd = (rule,value,callback) => {
        if (value === '') {
          callback(new Error('비밀번호를 입력해주세요.'))
        } else if (value !== this.form.pwd) {
          callback(new Error('비밀번호가 일치하지 않습니다.'))
        } else {
          callback()
        }
      }
      return {
        nav_title: '비밀번호 변경',
        username: '',
        custNo: '',
        httpTimestamp: 0,
        form: {
          pwd: '',
          pwdcheck: ''
        },
        rules: {
          pwd: [
            { required: true, message: '비밀번호를 입력해주세요.', trigger: 'blur' },
            { min: 8, max: 20, message: '8~20자 이내로 설정해주세요.', trigger: 'blur' }
          ],
          pwdcheck: [{ validator: validpwd, trigger: 'blur' }]
        }
      }
    },
    created () {
      app = this

      this.username = this.$route.params.username
      this.custNo = this.$route.params.custNo
    },
    methods: {
      handleSetPwd: function () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.httpTimestamp = (new Date).getTime()
            this.$showCustomLoading()

            requestUpdatePassword({
              custNo: this.custNo,
              password: this.form.pwd
            }).then(response => {
              setTimeout(function() {
                app.$dismissCustomLoading()

                app.$customAlert({
                  message: '비밀번호가 변경되었습니다.',
                  success: () => {
                    app.$router.push({ name: 'login' })
                  }
                })
              }, 1000 - ((new Date).getTime() - this.httpTimestamp))
            }).catch(function(error) {
              setTimeout(function() {
                app.$dismissCustomLoading()

                app.$customAlert({
                  message: error.response.data.message
                })
              }, 1000 - ((new Date).getTime() - app.httpTimestamp))
            })
          } else {
            return false
          }
        })
      },
      handleInputBlur () {
        document.body.scrollTop = document.body.scrollTop
      }
    }
  }
</script>

<style scoped>
  .setPwd{
    background-color: #F8F7F4;
  }

  .section{
    padding: 1.667rem 0 0 0;
    margin:0 1.042rem;
  }

  .userInfo{
    padding: 1.389rem 0;
  }

  .userInfo .userImage{
    width: 2rem;
    height: 2rem;
  }

  .userImage img {
    width: 100%;
    height: 100%;
  }

  .userEmail{
    padding: .45rem 0 0 0;
  }
  .userEmail > div{
    color: #9F9F9F!important;
  }

  .setpwd_btn{
    margin: 0.833rem 0 0.278rem 0!important; ;
  }

  .setpwd_tip{
    font-size: 0.333rem!important;
    color: #9F9F9F!important;
    line-height: 0.472rem;
  }

  .btn_big{
    margin: 0;
  }

</style>



// WEBPACK FOOTER //
// src/views/Account/Resetpassword.vue